const en_whs_serialnumber = {
    "": "serial number",
}

export default en_whs_serialnumber;